import moment from 'moment-timezone';

// Constantes
const DEPOSIT_CUTOFF_HOUR_UTC = 5; // 11 PM CDMX = 5 AM UTC
const MONDAY = 1;
const WEEKEND_DAYS_COVERAGE = 3; // Lunes cubre Vie-Dom
const REGULAR_DAYS_COVERAGE = 1; // Otros días cubren día anterior

/**
 * Calcula el rango de fechas del ciclo de depósito
 * @param {string} depositDate - Fecha del depósito en formato ISO
 * @returns {{from: moment.Moment, to: moment.Moment}} Rango del ciclo
 */
export const calculateDepositCycle = (depositDate) => {
  const depositMoment = moment.utc(depositDate);
  const dayOfWeek = depositMoment.day();
  
  const daysToSubtract = dayOfWeek === MONDAY 
    ? WEEKEND_DAYS_COVERAGE 
    : REGULAR_DAYS_COVERAGE;
  
  const cycleStart = depositMoment
    .clone()
    .subtract(daysToSubtract, 'days')
    .hour(DEPOSIT_CUTOFF_HOUR_UTC)
    .minute(0)
    .second(0)
    .millisecond(0);
    
  const cycleEnd = depositMoment
    .clone()
    .hour(DEPOSIT_CUTOFF_HOUR_UTC)
    .minute(0)
    .second(0)
    .millisecond(0);
  
  return { from: cycleStart, to: cycleEnd };
};

/**
 * Formatea el rango de ciclo para display
 * @param {string} depositDate - Fecha del depósito
 * @returns {string} Rango formateado (ej: "12/12/2025 - 15/12/2025")
 */
export const formatCycleRange = (depositDate) => {
  const { from, to } = calculateDepositCycle(depositDate);
  return `${from.format('DD/MM/YYYY')} - ${to.format('DD/MM/YYYY')}`;
};
